import { render, staticRenderFns } from "./about-us-modal-alert.vue?vue&type=template&id=67102076&"
import script from "./about-us-modal-alert.vue?vue&type=script&lang=js&"
export * from "./about-us-modal-alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports